import script from "./history.vue?vue&type=script&setup=true&lang=ts"
export * from "./history.vue?vue&type=script&setup=true&lang=ts"

import "../style/history.css?vue&type=style&index=0&id=5494189c&scoped=true&lang=css&external"
import "./history.vue?vue&type=style&index=1&id=5494189c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5494189c"]])

export default __exports__